svg<app-header-seller></app-header-seller>
<app-sidebar-seller></app-sidebar-seller>
<div class="wrpmain">
	<div class="container">
		<!--- HEAD  --->
		<div class="row align-items-center mb-4 pinfo-head">
			<div class="col-sm-6 col-7 pr-0">
				<h3 class="fs24 wt700 txtdefault">Charges and Commission Report</h3>
				<nav class="breadcrumb breadcrumb-dui mb-0">
					<ol class="breadcrumb p-0 bg-transparent  mb-0">
						<li class="breadcrumb-item">
							<a class="txtseconday" href="javascript:void(0);">My Business Reports</a>
						</li>
						<li class="breadcrumb-item">
							<a class="txtseconday" [routerLink]="['/payment-reports']">Payment Report</a>
						</li>
						<li class="breadcrumb-item active">Charges and Commission Report</li>
					</ol>
				</nav>
			</div>
			<div class="col-sm-6 col-5 text-right pl-0">
				<a href="javascript:void(0);" [routerLink]="['/seller/assistance']" class="btn buybtn fs16 radius10 ripple">Assistance</a>
			</div>
		</div>
		<!--- /HEAD  --->
		<div class="card cardui carduipro p-4 mb-0">

			<div class="custom-tabs">
				<ul>
					<li><a [routerLink]="['/consolidated-payment-report']">Consolidated Payment</a></li>
					<li><a [routerLink]="['/wallet-transaction']">Wallet Transaction</a></li>
					<li><a [routerLink]="['/outstanding-payment']">Outstanding Payment</a></li>
					<li><a [routerLink]="['/settled-payment']">Settled Payment</a></li>
					<li><a [routerLink]="['/charges-and-commission']" class="active">Charges and Commission</a></li>
					<li><a [routerLink]="['/refund-report']">Refund Report</a></li>
				</ul>
			</div>
			
			<!--Filters-->
      		<div class="row d-flex justify-content-between mt-20 report-cta">
				<div class="col-md-4">
					<div class="form-container mt-0 mb-0 mr-3">
						<div class="report-input floating-label">
							<div class="input-group-custom">
								<input type="text" value="27/08/2021 - 27/09/2021" class="form-control" placeholder=" " />
								<span class="highlight"></span>
								<label>Date</label>
								<div class="input-group-append-custom">
									<img src="assets/images/icons/filter-calendar.svg">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--End Filters-->
        	<table class="table custom-table">
				<thead>
					<tr>
						<th>Report ID</th>
						<th>Report Name</th>
						<th>Report Status</th>
						<th>Date Range</th>
						<th>Generated on</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td><span class="processing">Generating…</span></td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>--/--/--  |  --:--:--</td>
						<td class="d-flex align-items-center processing-icons">
							<a href="javascript:;"><img src="assets/images/icons/pdf.svg"></a>
							<a href="javascript:;"><img src="assets/images/icons/xls.svg"></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
					<tr>
						<td>EBOR99875</td>
						<td>Charges & Commission Report - Dec 21</td>
						<td>Ready to download</td>
						<td>27/08/2021 - 27/09/2021</td>
						<td>27/08/2021, 12:54 pm</td>
						<td class="d-flex align-items-center">
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/pdf.svg" /></i></a>
							<a href="javascript:;"><i placement="top" ngbTooltip="File size: 75kb"><img src="assets/images/icons/xls.svg"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row mb-40">
			<div class="col-md-6">
				<div class="text-left pl-3">
					<nav class="mt-3 tbpg rows-per-page">
						<div>Rows per page:</div>
						<select class="select-box">
							<option>10</option>
							<option>20</option>
						</select>
					</nav>
				</div> 
			</div>
			<div class="col-md-6">
				<div class="text-right pr-3">
					<nav class="mt-3 tbpg">
					  <ul class="pagination align-items-center">
						<li class="page-item"><a class="page-link previcon" href="#"></a></li>
						<li class="page-item"><a class="page-link sprevicon" href="#"></a></li>
						<li class="page-item"><a class="page-link" href="#">1</a></li>
						<li class="page-item"><a class="page-link" href="#">2</a></li>
						<li class="page-item"><a class="page-link" href="#">3</a></li>
						<li class="page-item"><a class="page-link" href="#">4</a></li>
						<li class="page-item"><a class="page-link snexticon" href="#"></a></li>
						<li class="page-item"><a class="page-link nexticon" href="#"></a></li>
					  </ul>
					</nav>
				</div> 
			</div>
		</div> 
	</div>
</div>